import { render } from "./CustomMultiSelect.vue?vue&type=template&id=1906dc42"
import script from "./CustomMultiSelect.vue?vue&type=script&lang=js"
export * from "./CustomMultiSelect.vue?vue&type=script&lang=js"

import "./CustomMultiSelect.vue?vue&type=style&index=0&id=1906dc42&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__